import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const FacilitiesSection = () => {
  const [facilities, setFacilities] = useState([]);

  useEffect(() => {
    fetch("https://immaculatenursingkkl.org/iihs/api/get_facilities.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setFacilities(data.data);
      })
      .catch((err) => console.error("Error fetching facilities:", err));
  }, []);

  return (
    <div className="gdlr-core-pbf-sidebar-wrapper" style={{ margin: "30px 0" }}>
      <div className="gdlr-core-pbf-sidebar-container gdlr-core-line-height-0 clearfix gdlr-core-js gdlr-core-container">

        {/* Title */}
        <div className="gdlr-core-pbf-element">
          <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr col-md-6" style={{ paddingBottom: 0, textAlign: "center" }}>
            <div className="gdlr-core-title-item-title-wrap clearfix text-center">
              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title" style={{ fontSize: "30px", fontWeight: 600, color: "#000", marginRight: "30px" }}>Facilities</h3>
            </div>
          </div>
        </div>

        {/* Facility Boxes */}
        <div className="gdlr-core-pbf-sidebar-content gdlr-core-column-40 gdlr-core-pbf-sidebar-padding gdlr-core-line-height gdlr-core-column-extend-left" style={{ padding: "35px 0px 20px 0px" }}>
          <div className="gdlr-core-pbf-sidebar-content-inner">
            <div className="facility-boxes-wrapper" style={{ display: "flex", flexWrap: "wrap" }}>
              {facilities.map((facility, idx) => (
                <div key={idx} className="gdlr-core-pbf-column gdlr-core-column-20">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ margin: "0px 0px 0px -7px" }}>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-feature-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                          <div className="gdlr-core-feature-box gdlr-core-js gdlr-core-feature-box-type-outer" style={{ backgroundColor: "#7c1c1b", borderRadius: "3px" }}>
                            <div className="gdlr-core-feature-box-content gdlr-core-sync-height-content">
                              <h3 className="gdlr-core-feature-box-item-title" style={{ fontSize: "14px", fontWeight: 600, color: "#fff" }}>{facility.name}</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Divider */}
            <div className="gdlr-core-pbf-element">
              <div className="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align">
                <div className="gdlr-core-divider-line gdlr-core-skin-divider" style={{ borderColor: "#ffcb05", borderBottomWidth: "3px" }}></div>
              </div>
            </div>

            {/* Description */}
            {facilities.length > 0 && (
              <div className="gdlr-core-pbf-element">
                <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                  <div className="gdlr-core-text-box-item-content" style={{ fontSize: "17px" }}>
                    <p>{facilities[0].description}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right Sidebar Slider */}
        <div className="gdlr-core-pbf-sidebar-right gdlr-core-column-extend-right kingster-sidebar-area gdlr-core-column-20 gdlr-core-pbf-sidebar-padding gdlr-core-line-height" style={{ padding: "35px 0px 30px 0px" }}>
          <div className="gdlr-core-sidebar-item gdlr-core-item-pdlr">
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={10}
              slidesPerView={1}
              loop={true}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              pagination={{ clickable: true }}
            >
              {facilities.map((facility, idx) => (
                <SwiperSlide key={idx}>
                  <div className="item">
                    <img src={facility.image_url} alt={facility.name} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

      </div>
    </div>
  );
};

export default FacilitiesSection;
